<template>
  <div
    :is="setPhotoViewer"
    :srcs="photoimages"
    :showcount="5"
    :margin="25"
    :showDescript="true"
    :topic="topic"
  />
</template>
<script>
import PhotoViewer from "@/components/otherTools/photoViewer.vue";
export default {
  components: {
    PhotoViewer
  },
  props: {
    item: {
      type: Object,
      default() {
        return {
          Sno: -1
        };
      }
    },
    topic: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      photoimages: [],
      setPhotoViewer: ""
    };
  },
  watch: {
    async "item.Sno"() {
      this.setPhotoViewer = "";
      this.photoimages = await this.SYS.getFileList(this.item, 2);
      if (this.photoimages.length > 0) {
        this.setPhotoViewer = "PhotoViewer";
      }
    }
  },
  mounted() {
    this.SYS.getFileList(this.item, 2).then(data => {
      this.setPhotoViewer = "";
      this.photoimages = data;
      if (data.length > 0) {
        this.setPhotoViewer = "PhotoViewer";
      }
    });
  }
};
</script>
<style lang="scss" scoped></style>
